import * as React from "react";
import CONSTS from "../../consts";
import ProductItem from "../product-item";
export default class ShoppingList extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const items = this.props.products.map((product, index) => {
            return React.createElement(ProductItem, { key: index, country: product.Country, category: product.ConsumerCategory, liqType: product.ConsumerType, showWhereToBuy: true, city: product.Region, title: product.Name, imgPath: `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${product.SKU ? product.SKU.trim() : "NotAvail"}.jpg`, sponsored: product.SponsoredSKU, id: product.DisplaySKU, madeInAlberta: product.MadeInAlberta, singlesPerUnit: product.SinglesPerUnit, size: product.Size });
        });
        return (React.createElement("div", { className: "products" }, items));
    }
}
;
//# sourceMappingURL=slist.js.map